
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-75.633 -69.434)"}},[_c('rect',{staticClass:"fg_background fg_background_stroke",attrs:{"width":"54.528","height":"88.428","rx":"9.088","ry":"9.825","x":"75.869","y":"69.67","fill":"#fff","fill-rule":"evenodd","stroke":"#000","stroke-width":".472"}}),_c('rect',{staticClass:"colorable",attrs:{"width":"45.44","height":"78.602","rx":"4.544","ry":"4.913","x":"80.413","y":"74.583","fill-rule":"evenodd"}}),_c('path',{staticClass:"fg_background",attrs:{"d":"M116.765 89.321c-20.077 0-36.352 17.596-36.352 39.301 0 5.426 4.069 9.825 9.088 9.825 20.077 0 36.352-17.595 36.352-39.3 0-5.427-4.069-9.826-9.088-9.826z","fill":"#fff","fill-rule":"evenodd"}})])])
          )
        }
      }
    